import React, { useState } from 'react';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { Form } from '@kuzmycz/react-form-ula';
import { Button, Modal } from '../../../../Components/uielements';
import BioPlusTextField from '../../../../Components/form-fields/BioPlusTextField';
import DropDown from '../../../../Components/uielements/dropDown';
import {
  ModalButtonWrapper,
  ModalWrapper,
  OutlineButton,
} from '../../../../services/settings/appStyle/global.style';
import User from '../../../../services/bioplus-services/user';
import { ModalLabel } from '../../UserV2/user.style';
import { TwoColumns } from '../company.style';
import { IntlMessages } from '../../../../helper/langHelper';

const options = [
  { value: true, label: 'True' },
  { value: false, label: 'False' },
];

const AccessControlModal = ({ onClose, data }) => {
  const [desktopAccess, setDesktopAccess] = useState();
  const [emergencyWarning, setEmergencyWarning] = useState();
  const [cvd, setCvd] = useState();
  const [sos, setSos] = useState();
  const [logBook, setLogBook] = useState();
  const [nvd, setNvd] = useState();
  // const [geteSign, setGateSign] = useState();
  // const [workSafety, setWorkSafety] = useState();
  const [timesheet, setTimesheet] = useState();
  const queryClient = useQueryClient();
  const query = useQuery(['accessControl', data?.id], () => User.getAccessControl(data?.id));
  const mutation = useMutation(User.updateAccessControl, {
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['users'] });
      await queryClient.invalidateQueries({ queryKey: ['user'] });
      await queryClient.invalidateQueries({ queryKey: ['accessControl'] });
      onClose();
    },
  });

  const handleSubmit = (values) => {
    const value = {
      ...values,
      ...(desktopAccess !== undefined && { desktopAccess: desktopAccess }),
      ...(emergencyWarning !== undefined && { emergencyWarning: emergencyWarning }),
      ...(cvd !== undefined && { cvd: cvd }),
      ...(sos !== undefined && { sos: sos }),
      ...(nvd !== undefined && { nvd: nvd }),
      ...(logBook !== undefined && { visitorLogBook: logBook }),
      // ...(geteSign !== undefined && { gateSignIn: geteSign }),
      // ...(workSafety !== undefined && { workSafety: workSafety }),
      ...(timesheet !== undefined && { timesheet: timesheet }),
    };

    mutation.mutate(value);
  };

  const validator = (values) => {
    return undefined;
  };

  const initialsData = {
    ...query.data,
    companyId: data?.id,
  };

  return (
    <>
      <Modal isOpen={true} onClose={onClose} title={<IntlMessages id="company.modal.title" />}>
        <Form initialValues={initialsData} validator={validator} onSubmit={handleSubmit}>
          <ModalWrapper>
            {query.isLoading ? (
              <ModalLabel>
                <IntlMessages id="loading.text" />
              </ModalLabel>
            ) : (
              <>
                <TwoColumns isGap={true}>
                  {/* <BioPlusTextField
                    label={<IntlMessages id="input.label.maxGeofences" />}
                    name="maxGeofences"
                    fullWidth
                  /> */}
                  <BioPlusTextField
                    label={<IntlMessages id="input.label.maxPremises" />}
                    name="maxPremises"
                    fullWidth
                  />
                  <DropDown
                    options={options}
                    selectedOption={(value) => setTimesheet(value.value)}
                    name="timesheet"
                    defaultValue={initialsData?.timesheet}
                    label={<IntlMessages id="input.label.timesheet" />}
                  />
                </TwoColumns>
                <TwoColumns isGap={true}>
                  <BioPlusTextField
                    label={<IntlMessages id="input.label.maxUsers" />}
                    name="maxUsers"
                    fullWidth
                  />
                  <DropDown
                    options={options}
                    selectedOption={(value) => setDesktopAccess(Boolean(value.value))}
                    name="desktopAccess"
                    defaultValue={initialsData?.desktopAccess}
                    label={<IntlMessages id="input.label.desktopAccess" />}
                  />
                </TwoColumns>
                <TwoColumns isGap={true}>
                  <DropDown
                    options={options}
                    selectedOption={(value) => setEmergencyWarning(value.value)}
                    name="emergencyWarning"
                    defaultValue={initialsData?.emergencyWarning}
                    label={<IntlMessages id="input.label.emergencyWarning" />}
                  />
                  <DropDown
                    options={options}
                    selectedOption={(value) => setCvd(value.value)}
                    name="cvd"
                    defaultValue={initialsData?.cvd}
                    label={<IntlMessages id="input.label.cvd" />}
                  />
                </TwoColumns>
                <TwoColumns isGap={true}>
                  <DropDown
                    options={options}
                    selectedOption={(value) => setSos(value.value)}
                    name="sos"
                    defaultValue={initialsData?.cvd}
                    label={<IntlMessages id="input.label.sos" />}
                  />
                  <DropDown
                    options={options}
                    selectedOption={(value) => setLogBook(value.value)}
                    name="visitorLogBook"
                    defaultValue={initialsData?.visitorLogBook}
                    label={<IntlMessages id="input.label.visitorLogBook" />}
                  />
                </TwoColumns>
                <TwoColumns isGap={true}>
                  <DropDown
                    options={options}
                    selectedOption={(value) => setNvd(value.value)}
                    name="nvd"
                    defaultValue={initialsData?.nvd}
                    label={<IntlMessages id="input.label.nvd" />}
                  />
                  {/* <DropDown
                    options={options}
                    selectedOption={(value) => setGateSign(value.value)}
                    name="gateSignIn"
                    defaultValue={initialsData?.gateSignIn}
                    label={<IntlMessages id="input.label.gateSignIn" />}
                  /> */}
                </TwoColumns>
                <TwoColumns isGap={true}>
                  {/* <DropDown
                    options={options}
                    selectedOption={(value) => setWorkSafety(value.value)}
                    name="workSafety"
                    defaultValue={initialsData?.workSafety}
                    label={<IntlMessages id="input.label.workSafety" />}
                  /> */}
                </TwoColumns>
              </>
            )}
            <ModalButtonWrapper>
              <OutlineButton onClick={onClose}>
                <IntlMessages id="modal.button.cancel" />
              </OutlineButton>
              <Button varient="normal" type="submit">
                <IntlMessages id="modal.button.change" />
              </Button>
            </ModalButtonWrapper>
          </ModalWrapper>
        </Form>
      </Modal>
    </>
  );
};

export default AccessControlModal;
